module.exports = __webpack_public_path__ + "img/2247411.png";